import { WorkflowTab } from "PFApp/workflow/workflow_store";
import { useTranslation } from "react-i18next";

type NoItemsProps = {
  itemType: WorkflowTab | "other";
};

export const NoItems = ({ itemType }: NoItemsProps) => {
  const { t } = useTranslation("workflow");

  return (
    <div style={{ padding: 30, textAlign: "center" }}>
      {itemType === WorkflowTab.Roles
        ? t("parts.noItems.roles")
        : itemType === WorkflowTab.Engagements
          ? t("parts.noItems.engagements")
          : t("parts.noItems.other")}
    </div>
  );
};
